import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});
async function getCsrfToken(): Promise<string> {
  const response = await fetch(`${BASE_URL}/csrf/token`, { method: "GET", credentials: "include" });
  const data = await response.json();
  return data.csrfToken;
}
function getToken() {
    return localStorage.getItem("d_c_c_t");
}


  export const getInformationUserRegister = async (
  formData: any
) => {
  try {
    const response = await fetch(
      "https://n8nio.pianat.ai/webhook/d6cb60ba-7b15-4a7f-b7a2-34fb27e4519d",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_data: formData }), // Changed to send as user_data object
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || "Failed to fetch company information");
    }

    const result = await response.json();
    if (!result[0]) {
      throw new Error("Invalid response structure");
    }

    return {
      success: true,
      companyData: result[0],
    };
  } catch (error: any) {
    return {
      success: false,
      message: error instanceof Error 
        ? error.message 
        : "Unexpected error during company info fetch",
    };
  }
};


// src/types/objectiveTypes.ts
export interface ApiObjective {
  objective_id: string;
  objective_name: string;
  description: string;
  estimated_effort: string;
  priority_rank: number;
  regulatory_reference: string;
  suggested_start_date: string;
  suggested_completion_date: string;
}

export interface CompanyData {
  organization_name: string;
  headquarters_country: string;
  industry_sectors: string[];
  entity_type: string;
  key_services: string[];
  company_size: {
    employees: number | null;
    revenue_band: string;
  };
  applicable_compliance_frameworks?: Array<{
    id: string;
    name: string;
    description?: string;
  }>;
}

export interface ApiResponse {
  success: boolean;
  data?: {
    roadmap?: ApiObjective[];
    data_sources?: string[];
    notes?: string;
  };
  message?: string;
}
export const getObjectiveInfoRegister = async (formData: any): Promise<ApiResponse> => {
  try {
    const response = await fetch(
      "https://n8nio.pianat.ai/webhook/advisor_agent_eg",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: formData }),
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || "Failed to fetch objectives");
    }

    const result = await response.json();

    // Handle the response structure you shared
    if (Array.isArray(result) && result.length > 0 && result[0].roadmap) {
      return {
        success: true,
        data: {
          roadmap: result[0].roadmap,
          data_sources: result[0].data_sources || [],
          notes: result[0].notes || ""
        }
      };
    }

    throw new Error("Invalid response structure");
  } catch (error: any) {
    return {
      success: false,
      message: error instanceof Error 
        ? error.message 
        : "Unexpected error during objectives fetch",
    };
  }
};

// Requires CSRF token
export async function submitObjectiveInfo(token: string, data: any[]): Promise<any> {
  const csrfToken = await getCsrfToken();

  const response = await fetch(`${BASE_URL}/registration-steps/objective-info?token=${token}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({ data }),
  });

  const result = await response.json();

  if (result.isSuccess && result.data?.token) {
    localStorage.setItem("token", result.data.token);
  }

  return result;
}

export async function getInformationUser() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/information/user`, {
      method: 'GET',
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error('Failed to fetch user information');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching user information:', error);
    throw new Error('Error fetching user information');
  }
}



    export async function submitComplianceByFramwork(data: any) {
      const token = getToken();
      try {
        const response = await fetch(`${BASE_URL}/compliance/bulk`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'X-CSRF-Token': await getCsrfToken(),
          },
          body: JSON.stringify(data),
        });
    
        if (!response.ok) {
          throw new Error(`Failed to submit answers. Status: ${response.status}`);
        }
    
        const result = await response.json();
        return result;
      } catch (error) {
        console.error('Error submitting answers:', error);
        throw error;
      }
    }
    



    export async function getMappedObjectives(data: any) {
  try {
    const response = await fetch(
      "https://n8nio.pianat.ai/webhook/60f7bc39-248f-4b01-a3ab-bb28d2e1308f",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data }),
      }
    );

    if (!response.ok) {
      throw new Error(`Mapper Agent failed with status: ${response.status}`);
    }

    const result = await response.json();
    return result; // Expecting output[], data_sources[]
  } catch (error) {
    console.error("Error calling Mapper Agent:", error);
    throw error;
  }
}



export async function mapControls(data: { applicable_frameworks: string[] }) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/controls/mapper`, {
      method: 'POST',
      body: JSON.stringify({
        applicable_frameworks: data.applicable_frameworks,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error mapping controls:', error);
    throw new Error('Error mapping controls');
  }
}

/**
 * Get objectives from backend for the current user
 * @returns Promise with objectives data or null if not found
 */
export async function getObjectivesFromBackend(): Promise<any[] | null> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/objectives`, {
      method: 'GET',
    });

    if (!response.ok) {
      if (response.status === 404) {
        return null; // No objectives found
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    // Check if result is successful and has data
    if (result.success && result.data) {
      // The data field contains the array from the AI response
      // result.data is the Objective model, and result.data.data is the actual array
      if (result.data.data && Array.isArray(result.data.data) && result.data.data.length > 0) {
        return result.data.data;
      }
    }
    return null;
  } catch (error) {
    console.error('Error fetching objectives from backend:', error);
    return null;
  }
}

/**
 * Save objectives to backend
 * @param data - Array of objective data from AI API response
 * @returns Promise with success status
 */
export async function saveObjectivesToBackend(data: any[]): Promise<{ success: boolean; message?: string }> {
  try {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        success: false,
        message: 'Invalid data format. Expected a non-empty array.',
      };
    }

    const response = await authService.apiCall(`${BASE_URL}/objectives`, {
      method: 'POST',
      body: JSON.stringify({ data }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return {
      success: result.success || false,
      message: result.message,
    };
  } catch (error: any) {
    console.error('Error saving objectives to backend:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to save objectives',
    };
  }
}

/**
 * Get control mapper data from backend for the current user
 * @returns Promise with control mapper data or null if not found
 */
export async function getControlMapperFromBackend(): Promise<any | null> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/control-mapper`, {
      method: 'GET',
    });

    if (!response.ok) {
      if (response.status === 404) {
        return null; // No control mapper data found
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    // Check if result is successful and has data
    if (result.success && result.data) {
      // The data field contains the control mapper model, and result.data.data is the actual data object
      if (result.data.data && typeof result.data.data === 'object') {
        // Check if it has the expected structure (individual and grouped arrays)
        if (
          (result.data.data.individual && Array.isArray(result.data.data.individual)) ||
          (result.data.data.grouped && Array.isArray(result.data.data.grouped))
        ) {
          return result.data.data;
        }
      }
    }
    return null;
  } catch (error) {
    console.error('Error fetching control mapper from backend:', error);
    return null;
  }
}

/**
 * Save control mapper data to backend
 * @param data - Control mapper data object from AI API response (with individual and grouped arrays)
 * @returns Promise with success status
 */
export async function saveControlMapperToBackend(data: {
  individual?: any[];
  grouped?: any[];
}): Promise<{ success: boolean; message?: string }> {
  try {
    if (!data || (typeof data !== 'object')) {
      return {
        success: false,
        message: 'Invalid data format. Expected an object with individual and/or grouped arrays.',
      };
    }

    // Validate that at least one of the arrays exists and is not empty
    if (
      (!data.individual || !Array.isArray(data.individual) || data.individual.length === 0) &&
      (!data.grouped || !Array.isArray(data.grouped) || data.grouped.length === 0)
    ) {
      return {
        success: false,
        message: 'Invalid data format. Expected at least one non-empty array (individual or grouped).',
      };
    }

    const response = await authService.apiCall(`${BASE_URL}/control-mapper`, {
      method: 'POST',
      body: JSON.stringify({ data }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return {
      success: result.success || false,
      message: result.message,
    };
  } catch (error: any) {
    console.error('Error saving control mapper to backend:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to save control mapper',
    };
  }
}


